import { css } from 'styled-components';
import token from 'styled-token';
import { typographyMixin } from '../typographyMixin';

/** @class MenuContentMixin */
/**
 * Standalone styles for menu text content.
 *
 * @example
 * import { MenuContentMixin } from "@zillow/constellation";
 *
 * const Component = styled.p`
 *     ${MenuContentMixin}
 * `;
 *
 * <Component>Menu content</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
export var MenuContentMixin = function MenuContentMixin(props) {
  return token({
    fontType: 'MenuContent.fontType',
    horizontalSpacing: 'MenuContent.horizontalSpacing',
    verticalSpacing: 'MenuContent.verticalSpacing',
    margin: 'MenuContent.margin'
  }, function (_ref) {
    var fontType = _ref.fontType,
      horizontalSpacing = _ref.horizontalSpacing,
      verticalSpacing = _ref.verticalSpacing,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin;
    return css(["", " margin:", "px;padding:", "px ", "px;"], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), margin, verticalSpacing, horizontalSpacing);
  })(props);
};